/* global Plotly:true */

import React, { Component } from "react";
import createPlotlyComponent from "react-plotly.js/factory";
import { cumulative } from "../lib/prob";

/* (Note that Plotly is already defined from loading plotly.js through a <script> tag) */
const Plot = createPlotlyComponent(Plotly);

class ProbPlot extends Component {
    render() {
        const BAR_LINE_TRANSITION = 50;
        let mode = "bar";
        let plotSeries = this.props.probDistFn.slice(0);

        if (this.props.probDistFn.length > BAR_LINE_TRANSITION) {
            mode = "line";
            let numZeros = parseInt(this.props.probDistFn.length*0.2, 10);
            // can't mutate this.props
            plotSeries = this.props.probDistFn.concat(new Array(numZeros).fill(0));
        }

        return <Plot
            config={{ displayModeBar: false }}
            
            data={[
                {
                    type: mode,
                    y: plotSeries,
                    name: "probability"
                },
                {
                    type: "line",
                    y: cumulative(plotSeries),
                    yaxis: "y2",
                    name: "cumulative prob.",
                    line: {dash: "dot"},
                }
            ]}

            layout={{
                width: 600,
                height: 400,
                margin: {
                    l: 30,
                    r: 30,
                    t: 10,
                    b: 50,
                    pad: 0,
                    autoexpand: false
                },
                legend: {
                    x: 0.02,
                    y: 1,
                },
                bargap: 0.01,
                xaxis: {
                    title: "Total duration /" + this.props.unit,
                    range: [-0.5, plotSeries.length - 0.5],
                    tickmode: mode === "bar" ? "linear" : null,
                    dtick: mode === "bar" ? Math.floor(plotSeries.length / 10) : null,
                    tick0: 0,
                    zeroline: mode === "line",
                    showgrid: mode === "line",
                },
                yaxis: {
                    showticklabels: false, //(mode == 'bar'),
                    title: "", // 'probability'
                    showgrid: false,
                    range: [0, 1.2 * Math.max(...plotSeries)]
                },
                yaxis2: {
                    showticklabels: false,
                    title: "", //'cumulative probability',
                    overlaying: "y",
                    side: "right",
                    showgrid: false,
                    range: [0, 1.1]
                }
            }}
        />;
    }
}

export default ProbPlot;

    


// WEBPACK FOOTER //
// ./src/components/ProbPlot.js